
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#EB5757","d":"M64 61.99H18.08C7.23 61.99 4.17 53.4 4 49.1c0-9.93 6.56-13.88 10.57-14.84l.2-.05a.92.92 0 00.72-.88v-.18C16 21.06 26.05 18 31.14 18c8.71 0 12.79 4.92 14.35 9.06l.5 1.32c.36.81.5.87 1.32.5l1.47-.74c1.2-.61 2.46-.92 3.22-1.02 9.52 0 12.24 6.55 12.5 10.69l.03.25c.06.53.35.82.87.88l.25.02c8.63.59 10.52 7.99 10.35 11.76 0 9.45-8 11.45-12 11.27z"}}),_c('path',{attrs:{"fill":"#fff","fill-rule":"evenodd","d":"M33.21 37.16a1.94 1.94 0 013.02-1.58l5.94 3.87 5.73 3.72a1.86 1.86 0 010 3.15l-11.67 7.6c-1.29.83-3.02-.07-3.02-1.58V37.16z","clip-rule":"evenodd"}})])
          )
        }
      }
    